import { render, staticRenderFns } from "./CalendarPageContentYear.vue?vue&type=template&id=425e9daa&scoped=true"
import script from "./CalendarPageContentYear.vue?vue&type=script&lang=js"
export * from "./CalendarPageContentYear.vue?vue&type=script&lang=js"
import style0 from "./CalendarPageContentYear.vue?vue&type=style&index=0&id=425e9daa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425e9daa",
  null
  
)

export default component.exports